export default __webpack_public_path__ + "static/vision_black-657cf4e4060cebc857f40d46ec778efb.png";